<agpr-take-over-panel
    [id]="'rssFeedManageDialog'"
    header="RSSFeeds.manage"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    (visibleChange)="cancel()"
    [hideSlideOverlay]="hideSlideOverlay"
    [responsiveWidth]="true"
    [minPanelWidth]="1000"
    [maxPanelWidth]="1300"
>
    <div class="agpr-rssFeedManageDialog-content">
        <div class="agpr-rssFeedManageDialog-feedList">
            <agpr-scroll-panel class="agpr-rssFeedManageDialog-feedList-scrollPanel">
                <agpr-table
                    [id]="'existingRssFeedTable'"
                    [columns]="columnDefs"
                    [sortColumn]="nameColumn"
                    [sortAscending]="true"
                    [(ngModel)]="dataRows"
                    (ngModelChange)="checkForSelectedFeeds()"
                    (itemChanged)="saveFeed($event)"
                ></agpr-table>
            </agpr-scroll-panel>
        </div>
    </div>
    <ng-template #takeOverFooterRight>
        <agpr-button
            *ngIf="hasSelectedFeeds"
            label="Core.button.delete"
            [style]="buttonTypes.primaryB"
            (click)="deleteSelectedFeeds()"
        ></agpr-button>
        <agpr-button
            label="RSSFeeds.createNew"
            [id]="'rssFeedManageDialog.createButton'"
            [style]="buttonTypes.primaryB"
            class="agpr-rssFeedManageDialog-newFeedButton"
            (click)="showCreateDialog()"
        ></agpr-button>
        <agpr-button
            label="done"
            [style]="buttonTypes.primary"
            (click)="hideSlideOverlay = true;"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>

<ng-template let-row="row" let-column="column" #descriptionCell>
    <a
        class="agpr-rssFeedManageDialog-descriptionCell-url"
        [href]="row.url"
        target="_blank"
        tabindex="-1"
    >
        {{row.url}}
    </a>
</ng-template>

<ng-template let-row="row" let-column="column" #itemsLimitCell>
    <div class="agpr-rssFeedManageDialog-customCell">
        <agpr-dropdown
            [id]="'rssFeedManageDialog_itemLimitDropdown'"
            class="agpr-rssFeedManageDialog-customCell-dropdown"
            [options]="itemsLimitOptions"
            [isInTable]="true"
            [(ngModel)]="row.maxItems"
            (ngModelChange)="saveFeed(row)"
            [infoCircleTooltip]="'RSSFeeds.manageDialog.feedInformation' | localize : {
                createdDate: row.createdDate,
                createdBy: row.createdByUser,
                modifiedDate: row.lastModifiedDate,
                modifiedBy: row.lastModifiedByUser
            }"
        ></agpr-dropdown>
    </div>
</ng-template>
<ng-template let-row="row" let-column="column" #customActionsCell>
    <div class="agpr-rssFeedManageDialog-customCell">
        <div
            class="agpr-rssFeedManageDialog-customCell-toggleButton"
            tabindex="-1"
        >
            <agpr-social-switch
                id="rssFeedManageDialog_actionSwitch"
                [tabindex]="'-1'"
                [(ngModel)]="row[column.field]"
                (ngModelChange)="saveFeed(row)"
                onText="RSSFeeds.manageDialog.feedState.enabled"
                offText="RSSFeeds.manageDialog.feedState.disabled"
            ></agpr-social-switch>
        </div>
        <agpr-button
            class="agpr-rssFeedManageDialog-customCell-deleteButton"
            [style]="buttonTypes.icon"
            icon="fa-regular fa-duotone fa-trash-can "
            tooltip="RSSFeeds.manageDialog.deleteButton"
            tooltipPosition="top"
            (click)="deleteFeed(row)"
        ></agpr-button>
    </div>
</ng-template>

